import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

const genId = () => `itm_${Date.now()}_${Math.random().toString(36).slice(2,6)}`;
const genSectionId = () => `sec_${Date.now()}_${Math.random().toString(36).slice(2,6)}`;
const inputStyle = { width:'100%', padding:'7px 8px', border:'1px solid #e2e8f0', borderRadius:6, fontSize:12, color:'#0f172a', outline:'none', boxSizing:'border-box' };

export default function ListEditor({ value, onChange }) {
  const map = value || { question:'', voicePrompt:'', variable:'', useCategories:false, items:[], sections:[] };
  const upd = (key, val) => onChange({ ...map, [key]: val });

  // Simple mode
  const addItem        = () => upd('items', [...(map.items||[]), { id:genId(), label:'' }]);
  const updateItem     = (idx, label) => { const a=[...(map.items||[])]; a[idx]={...a[idx],label}; upd('items',a); };
  const removeItem     = (idx) => upd('items', (map.items||[]).filter((_,i)=>i!==idx));

  // Category mode
  const addSection     = () => upd('sections', [...(map.sections||[]), { id:genSectionId(), title:'', items:[{ id:genId(), label:'' }] }]);
  const updSecTitle    = (si,title) => { const a=[...(map.sections||[])]; a[si]={...a[si],title}; upd('sections',a); };
  const removeSection  = (si) => upd('sections', (map.sections||[]).filter((_,i)=>i!==si));
  const addSecItem     = (si) => { const a=[...(map.sections||[])]; a[si]={...a[si],items:[...(a[si].items||[]),{id:genId(),label:''}]}; upd('sections',a); };
  const updSecItem     = (si,ii,label) => { const a=[...(map.sections||[])]; const it=[...(a[si].items||[])]; it[ii]={...it[ii],label}; a[si]={...a[si],items:it}; upd('sections',a); };
  const removeSecItem  = (si,ii) => { const a=[...(map.sections||[])]; a[si]={...a[si],items:a[si].items.filter((_,i)=>i!==ii)}; upd('sections',a); };

  const toggleCategories = () => {
    const next = !map.useCategories;
    if (next && !(map.sections||[]).length) {
      // Auto-add one default category with one option when enabling
      onChange({ ...map, useCategories: true, sections: [{ id:genSectionId(), title:'', items:[{ id:genId(), label:'' }] }] });
    } else {
      upd('useCategories', next);
    }
  };

  const totalOptions = map.useCategories
    ? (map.sections||[]).reduce((acc,s)=>acc+(s.items||[]).length,0)
    : (map.items||[]).length;

  return (
    <div style={{ padding:16, display:'flex', flexDirection:'column', gap:14 }}>

      {/* Question */}
      <div>
        <label style={{ fontSize:11, fontWeight:700, color:'#475569', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.06em' }}>Header</label>
        <textarea value={map.question||''} onChange={e=>upd('question',e.target.value)} onKeyDown={e=>e.stopPropagation()}
          placeholder="Which option would you like?" rows={2}
          style={{ ...inputStyle, resize:'vertical', fontFamily:'inherit' }}/>
      </div>

      {/* Voice Prompt */}
      <div style={{ background:'#eef2ff', borderRadius:8, padding:12, border:'1px solid #c7d2fe' }}>
        <label style={{ fontSize:11, fontWeight:700, color:'#4f46e5', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.06em' }}>🎙 Voice Prompt</label>
        <textarea value={map.voicePrompt||''} onChange={e=>upd('voicePrompt',e.target.value)} onKeyDown={e=>e.stopPropagation()}
          placeholder="Would you like to check your balance, transfer funds, or speak to an agent?"
          rows={2} style={{ ...inputStyle, resize:'vertical', fontFamily:'inherit', border:'1px solid #c7d2fe', background:'#fff' }}/>
        <p style={{ fontSize:10, color:'#818cf8', marginTop:4 }}>Spoken in voice mode. LLM matches response to option. Each option has its own connecting handle →</p>
      </div>

      {/* Category toggle */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 12px', background:'#f8fafc', borderRadius:8, border:'1px solid #e2e8f0' }}>
        <div>
          <p style={{ fontSize:12, fontWeight:600, color:'#0f172a' }}>Use Categories</p>
          <p style={{ fontSize:10, color:'#94a3b8', marginTop:2 }}>Group options under section headers</p>
        </div>
        <button onClick={toggleCategories}
          style={{ width:40, height:22, borderRadius:11, border:'none', cursor:'pointer', background:map.useCategories?'#4f46e5':'#e2e8f0', position:'relative', transition:'background 0.2s' }}>
          <div style={{ width:16, height:16, borderRadius:'50%', background:'#fff', position:'absolute', top:3, left:map.useCategories?21:3, transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)' }}/>
        </button>
      </div>

      {/* Options header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <label style={{ fontSize:11, fontWeight:700, color:'#475569', textTransform:'uppercase', letterSpacing:'0.06em' }}>
          {map.useCategories ? 'Categories & Options' : 'Options'}
          <span style={{ fontSize:10, fontWeight:400, color:'#94a3b8', marginLeft:6 }}>({totalOptions} · each has own handle →)</span>
        </label>
        <button onClick={map.useCategories ? addSection : addItem}
          style={{ padding:'4px 10px', fontSize:11, fontWeight:600, color:'#4f46e5', background:'#eef2ff', border:'none', borderRadius:6, cursor:'pointer', display:'flex', alignItems:'center', gap:4 }}>
          <FiPlus size={11}/> {map.useCategories ? 'Add Category' : 'Add Option'}
        </button>
      </div>

      {/* Simple mode */}
      {!map.useCategories && (
        <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
          {(map.items||[]).map((item, idx) => (
            <div key={item.id||idx} style={{ display:'flex', gap:6, alignItems:'center' }}>
              <div style={{ width:20, height:20, borderRadius:'50%', background:'#a855f7', display:'flex', alignItems:'center', justifyContent:'center', fontSize:9, fontWeight:700, color:'#fff', flexShrink:0 }}>{idx+1}</div>
              <input value={item.label||''} onChange={e=>updateItem(idx,e.target.value)} onKeyDown={e=>e.stopPropagation()}
                placeholder={`Option ${idx+1}`}
                style={{ flex:1, padding:'7px 8px', border:'1px solid #e2e8f0', borderRadius:6, fontSize:12, color:'#0f172a', outline:'none' }}/>
              <span style={{ fontSize:9, color:'#a855f7', fontWeight:700 }}>→</span>
              <button onClick={()=>removeItem(idx)} style={{ padding:4, color:'#dc2626', background:'#fef2f2', border:'none', borderRadius:4, cursor:'pointer', display:'flex' }}><FiTrash2 size={12}/></button>
            </div>
          ))}
          {!(map.items||[]).length && <p style={{ fontSize:12, color:'#94a3b8', textAlign:'center', padding:12 }}>No options yet. Click Add Option.</p>}
        </div>
      )}

      {/* Category mode */}
      {map.useCategories && (
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {!(map.sections||[]).length && <p style={{ fontSize:12, color:'#94a3b8', textAlign:'center', padding:12 }}>No categories yet. Click Add Category.</p>}
          {(map.sections||[]).map((section, si) => (
            <div key={section.id||si} style={{ border:'1px solid #e2e8f0', borderRadius:10, overflow:'hidden' }}>
              <div style={{ display:'flex', alignItems:'center', gap:6, padding:'8px 10px', background:'#f8fafc', borderBottom:'1px solid #e2e8f0' }}>
                <div style={{ width:8, height:8, borderRadius:'50%', background:'#a855f7', flexShrink:0 }}/>
                <input value={section.title||''} onChange={e=>updSecTitle(si,e.target.value)} onKeyDown={e=>e.stopPropagation()}
                  placeholder={`Category ${si+1} name`}
                  style={{ flex:1, padding:'4px 6px', border:'1px solid #e2e8f0', borderRadius:5, fontSize:11, fontWeight:600, color:'#0f172a', outline:'none', background:'#fff' }}/>
                <button onClick={()=>removeSection(si)} style={{ padding:3, color:'#dc2626', background:'#fef2f2', border:'none', borderRadius:4, cursor:'pointer', display:'flex' }}><FiTrash2 size={11}/></button>
              </div>
              <div style={{ padding:'8px 10px', display:'flex', flexDirection:'column', gap:5 }}>
                {(section.items||[]).map((item, ii) => (
                  <div key={item.id||ii} style={{ display:'flex', gap:6, alignItems:'center' }}>
                    <div style={{ width:16, height:16, borderRadius:'50%', background:'#ede9fe', display:'flex', alignItems:'center', justifyContent:'center', fontSize:8, fontWeight:700, color:'#7c3aed', flexShrink:0 }}>{ii+1}</div>
                    <input value={item.label||''} onChange={e=>updSecItem(si,ii,e.target.value)} onKeyDown={e=>e.stopPropagation()}
                      placeholder={`Option ${ii+1}`}
                      style={{ flex:1, padding:'5px 6px', border:'1px solid #e2e8f0', borderRadius:5, fontSize:11, color:'#0f172a', outline:'none' }}/>
                    <span style={{ fontSize:9, color:'#a855f7', fontWeight:700 }}>→</span>
                    <button onClick={()=>removeSecItem(si,ii)} style={{ padding:3, color:'#dc2626', background:'#fef2f2', border:'none', borderRadius:4, cursor:'pointer', display:'flex' }}><FiTrash2 size={11}/></button>
                  </div>
                ))}
                <button onClick={()=>addSecItem(si)}
                  style={{ padding:'4px 8px', fontSize:10, fontWeight:600, color:'#7c3aed', background:'#faf5ff', border:'1px dashed #ddd6fe', borderRadius:6, cursor:'pointer', display:'flex', alignItems:'center', gap:4, alignSelf:'flex-start', marginTop:2 }}>
                  <FiPlus size={10}/> Add Option
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Variable */}
      <div>
        <label style={{ fontSize:11, fontWeight:700, color:'#475569', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.06em' }}>Store Selection In</label>
        <input value={map.variable||''} onChange={e=>upd('variable',e.target.value.toLowerCase().replace(/\s+/g,'_'))} onKeyDown={e=>e.stopPropagation()}
          placeholder="selected_option" style={{ ...inputStyle, fontFamily:'monospace', color:'#4f46e5' }}/>
      </div>
    </div>
  );
}
